<template>
  <div>
    <v-dialog v-model="dialog" width="40%">
      <template v-slot:activator="{ on }">
        <v-btn small outline color="red lighten-2" dark v-on="on">{{$t('screener.embed.title')}}</v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{$t('screener.embed.title')}}
          <v-spacer></v-spacer>
           <v-btn @click="dialog=false" icon dark>
            <v-icon color="error">$vuetify.icons.rms_close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-layout row wrap >
              <v-flex xs12 md12 lg12>
                <!-- Title -->
                  <v-text-field
                    id="height"
                    :label="$t('screener.embed.iFrame.height')"
                    name="height"
                    outline
                    :rules="[
                      rules.required,
                    ]"
                    color="primary"
                    type="number"
                    v-model="height"
                  ></v-text-field>
              </v-flex>
              <v-flex xs12 md12 lg12>
                <v-text-field
                    id="width"
                    :label="$t('screener.embed.iFrame.width')"
                    name="width"
                    outline
                    :rules="[
                      rules.required,
                    ]"
                    color="primary"
                    type="number"
                    v-model="width"
                  ></v-text-field>
              </v-flex>
               <v-flex xs12 md6 lg6>
                 <v-checkbox :label="$t('screener.embed.height.in_percentage')" v-model="heightInPercentage"></v-checkbox>
              </v-flex>
               <v-flex xs12 md6 lg6>
                 <v-checkbox :label="$t('screener.embed.width.in_percentage')" v-model="widthInPercentage"></v-checkbox>
              </v-flex>
               <v-flex xs12 md6 lg6>
                 <v-checkbox :label="$t('screener.embed.allow_full_screen')" v-model="isFullScreenAllowed"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
          <v-card-text v-if="sourceCode" height="150px" class="bg_grey">
            <div>
              {{sourceCode}}
            </div>
          </v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="sourceCode" color="success" @click="$copyText(sourceCode)">Copy code</v-btn>
          <v-btn color="primary" @click="generateCode()">Generate</v-btn>
        </v-card-actions>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import rules from "@/validation";
import { mapState, mapGetters } from "vuex";
export default {
  name: "EmbedScreener",
  props: {
    screener: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      rules,
      dialog: false,
      height: 100,
      width: 100,
      isFullScreenAllowed: true,
      sourceCode:null,
      heightInPercentage: true,
      widthInPercentage: true
    };
  },
  computed:{
    ...mapGetters("company", {
      selected_company: "getSelectedCompany",
    }),
    iFrameURL(){
      return `${this.selected_company.domain}/screeners/${this.$route.params.screener_id}/?allowEmbed=${true}?isFullScreen=${this.isFullScreenAllowed}`
    }
  },
  methods: {
    generateCode() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.sourceCode = `<iframe src="${this.iFrameURL}" title="${this.screener.title}" height="${this.height}${this.heightInPercentage ?'%':'px'}" width="${this.width}${this.widthInPercentage ?'%':'px'}" allowfullscreen="${this.isFullScreenAllowed}"></iframe>`
    }
  }
};
</script>
<style scoped>
 .bg_grey{
   background-color: lightgray;
 }
</style>
